import { createContext, useContext, useLayoutEffect } from 'react';

/**
 * Phones show the page title in the app bar instead of "Sportplaner" (like a native app). The Shell keeps a list of
 * titles: each page adds its own while it is shown; the last one added wins (a form and its PageHead may both set
 * one – removing one never blanks the other).
 */
export interface BarTitles {
  add: (id: symbol, title: string) => void;
  remove: (id: symbol) => void;
}
export const BarTitleContext = createContext<BarTitles>({ add: () => {}, remove: () => {} });

/** Sets the app bar title on phones while the component is shown. */
export function useBarTitle(title: string | null | undefined) {
  const titles = useContext(BarTitleContext);
  // layout effect: the bar changes in the same frame as the page (route changes run as transitions)
  useLayoutEffect(() => {
    if (!title) return;
    const id = Symbol(title);
    titles.add(id, title);
    return () => titles.remove(id);
  }, [title, titles]);
}
